'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

_TransmuteCollection.has.implement(Array, function (key, arr) {
  return arr.hasOwnProperty(key);
});

_TransmuteCollection.has.implementInherited(_immutable.Iterable, function (key, subject) {
  return subject.has(key);
});

_TransmuteCollection.has.implement(Object, function (key, obj) {
  return obj.hasOwnProperty(key);
});

exports.default = _TransmuteCollection.has;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_has.js
// module id = 76
// module chunks = 0 1